export const MODULE_TYPE = {
    CATEGORY: 'category',
    SECTION: 'section',
    MODULE: 'module'
}